import apiService from './apiService';

// Get all leave rosters
export const getLeaveRosters = async (page: number = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      page: String(page),
    });

    if (search) {
      params.append('filter[search]', search);
    }

    const response = await apiService.get(`/leave-rosters?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching leave rosters:', error);
    throw error;
  }
};

// Get single leave roster
export const getLeaveRosterDetail = async (id: number | string) => {
  try {
    const response = await apiService.get(`/leave-rosters/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching leave roster detail:', error);
    throw error;
  }
};

// Create leave roster
export const createLeaveRoster = async (payload: any) => {
  try {
    const response = await apiService.post('/leave-rosters', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating leave roster:', error);
    throw error;
  }
};

// Update leave roster
export const updateLeaveRoster = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/leave-rosters/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating leave roster:', error);
    throw error;
  }
};

// Delete leave roster
export const deleteLeaveRoster = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/leave-rosters/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting leave roster:', error);
    throw error;
  }
};

// Get Leave Roster Groups
export const getLeaveRosterGroups = async () => {
  try {
    const response = await apiService.get('/shift-roster-groups');
    return response.data;
  } catch (error) {
    console.error('Error fetching leave roster groups:', error);
    throw error;
  }
};

export const updateLeave = async (payload: any) => {
  try {
    const response = await apiService.post(`/leave-rosters/leave`, payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const notifyLeaveRosterApproval = async (id: number, payload: any) => {
  try {
    const response = await apiService.post(`/leave-rosters/${id}/notify-approve`, payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOperationManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=9');

    return response.data;
  } catch (error) {
    console.error('Error fetching Operation Managers:', error);
    throw error;
  }
};

// Mark Leave Roster as Approved
export const markLeaveRosterApproved = async (id: number | string) => {
  try {
    const response = await apiService.post(
      `/leave-rosters/${id}/mark-approved`, // include ID in URL
      { leave_roster_id: id },
    );
    return response.data;
  } catch (error) {
    console.error('Error approving leave roster:', error);
    throw error;
  }
};

// Reject Leave Roster
export const rejectLeaveRoster = async (id: number | string, reason: string) => {
  try {
    const response = await apiService.post(
      `/leave-rosters/${id}/reject`, // ← Better URL
      { remarks: reason },
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting leave roster:', error);
    throw error;
  }
};

export const downloadLeaveRoster = async (id: number | string) => {
  try {
    const response = await apiService.get(`/leave-rosters/${id}/download`, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    console.error('Error downloading leave roster:', error);
    throw error;
  }
};
